import { axios } from '@/plugins/axios';

export default class AiFormGeneratorService
{
    /**
     * Generate form structure based on user prompt
     * @param userPrompt - User's natural language description of the form
     * @returns Promise<GeneratedFormResponse> - Generated form data
     */
    public static async generateForm(userPrompt: string): Promise<GeneratedFormResponse>
    {
        const response = await axios.post<GeneratedFormResponse>('logito-ai/dynamic-form-generator/generate', JSON.stringify(userPrompt), {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response.data;
    }
}

export interface GeneratedFormResponse {
    success: boolean;
    formData?: FormData;
    error?: string;
    message?: string;
}

export interface FormData {
    title: string;
    description: string;
    components: FormComponent[];
}

export interface FormComponent {
    id: string;
    type: string;
    name: string;
    label: string;
    required: boolean;
    placeholder?: string;
    options?: FormOption[];
    validation?: ValidationRule[];
}

export interface FormOption {
    value: string;
    text: string;
}

export interface ValidationRule {
    type: string;
    value?: any;
    message: string;
}
